<template>
  <sfs-form-modal
    :id="modalId"
    size="md"
    title="Import (Create or Update) Locations"
    @on-hide="resetFormData"
  >
    <imports-form
      description="Create or update locations."
      @on-submit="createLocationImport"
      @on-save="handleSave"
      @on-cancel="closeModal"
      :key="formKey"
    >
      <template #downloads>
        <b-row>
          <b-col cols="12">
            <sfs-download-button
              label="Download Template"
              filename="Locations Template.xlsx"
              :file-provider="$importsAPI.getLocationsTemplate"
            />
          </b-col>
        </b-row>
      </template>
    </imports-form>
  </sfs-form-modal>
</template>

<script>
import ImportsForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'LocationsImportsAddModal',
  mixins: [formModalMixin],
  components: {
    ImportsForm,
  },
  data() {
    return {
      modalId: 'locations-imports-add-modal',
    };
  },
  methods: {
    createLocationImport(data, handleCreate) {
      handleCreate(this.$importsAPI.locationsCreate(data));
    },
    handleSave(data) {
      if (this.$route.name != 'imports') {
        this.$router.push({ name: 'imports' });
      } else {
        this.closeModal();
      }
      this.$emit('on-save', data);
    },
  },
};
</script>
